@if(showNavigation) {
<div
  class="carousel-navigation d-flex gap-1 justify-content-end"
  [ngClass]="class"
>
  <button
    class="swiper-button-prev"
    (click)="navigateSlide('prev')"
    [disabled]="swiperInstance ? swiperInstance.isBeginning : true"
    >
    <mat-icon>arrow_back</mat-icon>
  </button>
  <button
    class="swiper-button-next"
    (click)="navigateSlide('next')"
    [disabled]="swiperInstance && !swiperInstance.isBeginning && swiperInstance.isEnd"
    >
    <mat-icon>arrow_forward</mat-icon>
  </button>

</div>
}
